import React, { Fragment } from 'react'

import type { Category } from '../../../../LaunchStrategy.types'
import { GuidesList } from '../GuidesList/GuidesList'
import * as S from './Navigation.styled'

type NavigationProps = {
  categories: Category[]
  activeGuideIndex: number
  activeCategoryIndex: number
  onChange: (categoryIndex: number, guideIndex: number) => void
  onGuideSelect?: () => void
}

export const Navigation = ({
  categories,
  activeCategoryIndex,
  activeGuideIndex,
  onChange,
  onGuideSelect,
}: NavigationProps) => {
  const handleCategoryChange = (categoryIndex: number) =>
    onChange(categoryIndex, categoryIndex === activeCategoryIndex ? activeGuideIndex : 0)

  return (
    <S.Container>
      {categories.map((category, categoryIndex) => (
        <Fragment key={category.title}>
          <S.CategoryButton
            key={`category${categoryIndex}`}
            active={activeCategoryIndex === categoryIndex}
            onClick={() => handleCategoryChange(categoryIndex)}
          >
            <S.Emoji>{category.emoji}</S.Emoji>
            {category.title}
          </S.CategoryButton>
          <GuidesList
            guides={category.guides}
            categoryIndex={categoryIndex}
            activeCategoryIndex={activeCategoryIndex}
            activeGuideIndex={activeGuideIndex}
            onChange={onChange}
            onGuideSelect={onGuideSelect}
          />
        </Fragment>
      ))}
    </S.Container>
  )
}
